import { useAuth } from "@/contexts/AuthContext";

export const useUserRole = () => {
  const { role, loading } = useAuth();
  return { role, loading };
};
